function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkopos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      display: "inline",
      opacity: 0.4,
      fill: "#0e0e0e",
      fillOpacity: 1,
      strokeWidth: 15,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 73v49.063h9.623v.085l12.61 12.61a7.8 7.8 0 0 1 3.349-.758 7.786 7.786 0 0 1 7.787 7.785 7.786 7.786 0 0 1-7.787 7.787 7.786 7.786 0 0 1-7.785-7.787 8 8 0 0 1 .082-1.125l-11.346-11.344H73V277.76h204V130.076h-6.533L259.12 141.42a8 8 0 0 1 .082 1.125 7.786 7.786 0 0 1-7.785 7.787 7.786 7.786 0 0 1-7.787-7.787 7.786 7.786 0 0 1 7.787-7.785 7.8 7.8 0 0 1 3.35.758l12.609-12.61v-.086H277V73h-5.998v12.1h-.352l.342.341-9.02 9.02a8 8 0 0 1 .157 1.547 7.786 7.786 0 0 1-7.787 7.785 7.786 7.786 0 0 1-7.785-7.785 7.786 7.786 0 0 1 7.785-7.787 7.8 7.8 0 0 1 3.008.605l6.4-6.4V73H86.25v8.666l6.4 6.4a7.8 7.8 0 0 1 3.008-.605 7.786 7.786 0 0 1 7.785 7.787 7.786 7.786 0 0 1-7.785 7.785 7.786 7.786 0 0 1-7.787-7.785 8 8 0 0 1 .156-1.547l-9.02-9.02.343-.341h-.352V73Zm69.48 16.912a7.786 7.786 0 0 1 7.786 7.787 7.786 7.786 0 0 1-7.786 7.787 7.786 7.786 0 0 1-7.787-7.787 7.786 7.786 0 0 1 7.787-7.787m65.04.76a7.786 7.786 0 0 1 7.787 7.787 7.786 7.786 0 0 1-7.787 7.787 7.786 7.786 0 0 1-7.786-7.787 7.786 7.786 0 0 1 7.786-7.787",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#bf2ae4",
      fillOpacity: 1,
      strokeWidth: 14.6434,
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.63 82.78v28.189a66.4 66.4 0 0 0-15.286 6.367l.418-.418-22.543-22.543-24.563 24.563 22.29 22.289a66.4 66.4 0 0 0-7.06 16.785H84.245v34.736h26.807a66.43 66.43 0 0 0 46.58 46.283v12.436h34.738V239.03a66.43 66.43 0 0 0 46.58-46.283h27.955v-34.736h-27.699a66.4 66.4 0 0 0-7.062-16.873l22.2-22.202-24.562-24.562-22.543 22.543.045.045a66.4 66.4 0 0 0-14.914-6.063V82.78ZM175 153.413a21.804 21.371 0 0 1 21.805 21.371A21.804 21.371 0 0 1 175 196.156a21.804 21.371 0 0 1-21.805-21.37A21.804 21.371 0 0 1 175 153.413",
    style: {
      opacity: 1,
      fill: "#0e0e0e",
      fillOpacity: 1,
      strokeWidth: 16.7377,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.924 236.186V278.2a26.651 18.664 0 0 0 26.65 18.664 26.651 18.664 0 0 0 26.65-18.664v-42.015zm21.77 17.072h9.761v17.816h-9.762z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 15,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.95 192.748-46.58 46.283 32.446 32.584 32.362-13.435 13.226-35.39zm-7.563 31.664a7.546 7.77 0 0 1 7.545 7.77 7.546 7.77 0 0 1-7.545 7.77 7.546 7.77 0 0 1-7.547-7.77 7.546 7.77 0 0 1 7.547-7.77",
    style: {
      opacity: 1,
      fill: "#0e0e0e",
      fillOpacity: 1,
      strokeWidth: 15,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.512 202.232-14.58 8.418-1.524 1.514 5.428 5.842-.014.015a15.5 15.5 0 0 1 6.565-1.468c8.63 0 15.627 6.998 15.627 15.629s-6.996 15.628-15.627 15.629-15.63-6.998-15.63-15.63c0-2.076.418-4.05 1.157-5.86l-.443.464-3.807-3.826h-2.918v-5.217h3.693v-11.916l-26.03 8.32-2.446 8.393 39.865 38.705 25.55-9.777 9.079-27.678z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 15,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m238.95 192.748-46.58 46.283 32.446 32.584 32.362-13.435 13.226-35.39zm-7.563 31.664a7.546 7.77 0 0 1 7.545 7.77 7.546 7.77 0 0 1-7.545 7.77 7.546 7.77 0 0 1-7.547-7.77 7.546 7.77 0 0 1 7.547-7.77",
    style: {
      opacity: 1,
      fill: "#0e0e0e",
      fillOpacity: 1,
      strokeWidth: 15,
      strokeLinejoin: "round"
    },
    transform: "matrix(-1 0 0 1 350 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.512 202.232-14.58 8.418-1.524 1.514 5.428 5.842-.014.015a15.5 15.5 0 0 1 6.565-1.468c8.63 0 15.627 6.998 15.627 15.629s-6.996 15.628-15.627 15.629-15.63-6.998-15.63-15.63c0-2.076.418-4.05 1.157-5.86l-.443.464-3.807-3.826h-2.918v-5.217h3.693v-11.916l-26.03 8.32-2.446 8.393 39.865 38.705 25.55-9.777 9.079-27.678z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 15,
      strokeLinejoin: "round"
    },
    transform: "matrix(-1 0 0 1 350 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175 119.523c-30.52 0-55.262 24.742-55.262 55.262q0 1.427.073 2.836c.023.459.069.911.103 1.367.036.481.061.964.11 1.442.027.267.068.53.1.797.075.656.15 1.313.25 1.962l.001.012q.209 1.355.48 2.688a56 56 0 0 0 .526 2.287c.032.127.057.257.09.385q.337 1.317.738 2.609c.198.638.419 1.265.639 1.892.08.228.15.46.232.686q.46 1.258.977 2.486l11.37-9.482a40.3 40.3 0 0 1-1.556-11.078c0-22.257 18.042-40.3 40.299-40.299.278 0 .553.016.83.021.277-.006.552-.021.83-.021 22.257 0 40.3 18.042 40.299 40.299 0 3.844-.551 7.557-1.557 11.078l11.371 9.482q.517-1.228.977-2.486l.008-.018c.08-.22.147-.446.225-.668.22-.627.44-1.254.638-1.892q.4-1.292.739-2.61l.002-.005c.032-.126.056-.254.087-.38a55 55 0 0 0 .526-2.287q.272-1.332.48-2.687l.004-.025q.207-1.36.348-2.74 0-.01.002-.018.14-1.385.21-2.79v-.007q.073-1.41.073-2.836c0-30.52-24.741-55.262-55.262-55.262m-38.44 77.66v17.286l.012.011a55 55 0 0 0 2.428 2.213l.04.034a55.4 55.4 0 0 0 11.081 7.398 55 55 0 0 0 9.442 3.72l.008.003 5.466-5.309-5.996-9.514.016.004c-7.842-3.185-14.45-8.773-18.928-15.845zm73.311 0c-4.477 7.073-11.086 12.66-18.928 15.846l.016-.004-5.996 9.514 5.467 5.309.008-.002a55 55 0 0 0 12.39-5.325 55.4 55.4 0 0 0 8.1-5.765l.115-.1a56 56 0 0 0 2.385-2.176l.012-.011v-17.286z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 19.7716,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.715 236.462-6.51 5.396v31.117h.031a17.37 13.655 0 0 0 9.01 11.555l4.68-.687v-2.303l-1.479-1.772.06-.02a9.304 7.828 0 0 1-4.22-6.286h-.018V240.16zm21.719 0-1.555 3.699v33.301h-.018a9.304 7.828 0 0 1-4.22 6.287l.06.02-1.478 1.77v2.304l4.68.687a17.37 13.655 0 0 0 9.01-11.555h.03v-31.117z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 19.101,
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkopos);
export default __webpack_public_path__ + "static/media/skopos.efc9ba8dc463f23015da21880e80aa71.svg";
export { ForwardRef as ReactComponent };